import { render } from "./category-detail.vue?vue&type=template&id=0931da53&scoped=true"
import script from "./category-detail.js?vue&type=script&lang=js&external"
export * from "./category-detail.js?vue&type=script&lang=js&external"

import "./category-detail.css?vue&type=style&index=0&id=0931da53&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0931da53"]])

export default __exports__